import SecurityPage from '../pages/security/page'

export const securityRoutes = [{ path: '/security', element: <SecurityPage /> }]
